import { render, staticRenderFns } from "./NewSign.vue?vue&type=template&id=1fd3a19c&scoped=true&"
import script from "./NewSign.vue?vue&type=script&lang=js&"
export * from "./NewSign.vue?vue&type=script&lang=js&"
import style0 from "./NewSign.vue?vue&type=style&index=0&id=1fd3a19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3a19c",
  null
  
)

export default component.exports